/**
 * FollowUpQuestion Component
 * 
 * Renders interactive follow-up question buttons
 * Following Mantine design system patterns
 */

import React from 'react';
import { Button, Box } from '@mantine/core';
import { IconMessageCircle } from '@tabler/icons-react';
import classes from './FollowUpQuestion.module.css';
import type { FollowUpQuestionProps } from '../types';

export const FollowUpQuestion: React.FC<FollowUpQuestionProps> = ({
  question,
  onClick
}) => {
  return (
    <Box className={classes.container}>
      <Button
        variant="light"
        leftSection={<IconMessageCircle size={16} />}
        className={classes.questionButton}
        onClick={() => onClick(question.text)}
      >
        {question.text}
      </Button>
    </Box>
  );
};